import type { ComponentType } from 'react'
import { useKioskBigBoardEnabled } from '@/lib/feature-flags'
import { usePermissionsBootstrap } from '@/lib/usePermissions'

interface KioskRouteSwitchProps {
  BigBoardPage: ComponentType
  LegacyPage: ComponentType
}

/** Shared authenticated host for both implementations of the location kiosk. */
export function KioskRouteSwitch({ BigBoardPage, LegacyPage }: KioskRouteSwitchProps) {
  const kioskToken = new URLSearchParams(window.location.search).get('kiosk')
  usePermissionsBootstrap(kioskToken)
  const enabled = useKioskBigBoardEnabled()

  return enabled ? <BigBoardPage /> : <LegacyPage />
}
